import { render, staticRenderFns } from "./ContainerSearch.vue?vue&type=template&id=0a47fff2&scoped=true"
import script from "./ContainerSearch.vue?vue&type=script&lang=js"
export * from "./ContainerSearch.vue?vue&type=script&lang=js"
import style0 from "./ContainerSearch.vue?vue&type=style&index=0&id=0a47fff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a47fff2",
  null
  
)

export default component.exports